import React from "react";
import { Helmet } from "react-helmet";
import { useLanguage } from "../../hooks/use-language";

export const MainPageMetadata = () => {
	const lang = useLanguage();
	return (
		<Helmet>
			<html lang={lang} />
			{/* <title>MakeMake - Digital Library</title>
			<meta name="description" content="Read" /> */}
		</Helmet>
	);
};
